import { ArrowUpRightIcon } from '@synoptic/ui-kit/icons/react/arrow-up-right.js';
import { FC } from 'react';
import { Link } from '@/routes-utils/navigation.tsx';
import { paths } from '@/routes-utils/paths.ts';
import * as awardStyles from './award-details.css.ts';

interface AwardDetailsProps {
  medalName: string;
  tournamentId: string;
  tournamentName: string;
}

export const AwardDetails: FC<AwardDetailsProps> = ({
  tournamentId,
  tournamentName,
  medalName,
}) => {
  return (
    <Link
      className={awardStyles.awardDetailsContainer}
      to={paths.makeTournament(tournamentId)}
    >
      <div className={awardStyles.header}>
        <span className={awardStyles.title}>{medalName}</span>
        <ArrowUpRightIcon />
      </div>
      <span className={awardStyles.tournamentIdentifier}>{tournamentName}</span>
    </Link>
  );
};
